<template>
    <div v-if="hasImportResult" class="import-result-tips">
        <template v-if="hasOtherError">
            上次导入失败
            <span class="import-result-time">{{ lastImportTime }}</span>
            {{ errMsg }}
        </template>
        <template v-else>
            上次导入
            <span class="import-result-time">{{ lastImportTime }}</span>
            导入成功<span :class="{ 'import-result-succ': hasImportSucc }">{{ importSuccNum }}</span
            >人，失败<span :class="{ 'import-result-fail': hasImportFail }">{{ importFailNum }}</span
            >人<template v-if="hasImportFail">，</template>
            <a v-if="hasImportFail" :href="downloadUrl" target="_self">下载失败列表</a>
        </template>
    </div>
</template>

<script>
import Gateway from '@/utils/Gateway';
import { envDomain } from 'src/utils/domainConfig';

export default {
    data() {
        return {
            lastImportTime: '',
            importSuccNum: 0,
            importFailNum: 0,
            downloadUrl: `${envDomain.gateway}/v1/wework/addressbook/exportManualFailedList`,
            hasOtherError: false,
            errMsg: ''
        };
    },
    computed: {
        hasImportSucc() {
            return this.importSuccNum > 0;
        },

        hasImportFail() {
            return this.importFailNum > 0;
        },

        hasImportResult() {
            return this.hasImportSucc || this.hasImportFail || this.hasOtherError;
        }
    },

    created() {
        this.getImportResult();
    },

    methods: {
        getImportResult() {
            Gateway.get('/v1/wework/ManualImportResult').then(data => {
                const { success, fail, last_sync_time: syncTime, message } = data || {};

                if (fail || success) {
                    this.importSuccNum = success;
                    this.importFailNum = fail;
                } else {
                    this.hasOtherError = true;
                }

                this.lastImportTime = syncTime;
                this.errMsg = message;
            });
        }
    }
};
</script>
<style scoped lang="less">
@import './import-result.less';
</style>
